export default "__VITE_ASSET__DP78_48z__"